import { render, staticRenderFns } from "./CountdownTimer.vue?vue&type=template&id=85a48136&scoped=true&"
import script from "./CountdownTimer.vue?vue&type=script&lang=js&"
export * from "./CountdownTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a48136",
  null
  
)

export default component.exports